import __request__ from "routing/request";
export function handleEventProcedureAction(stepId, eventId, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp/event_procedure_actions", null, { "stepId": stepId, "eventId": eventId }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function handleBulkEventProcedureAction(JSONBody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp/event_procedure_actions/bulk", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
